
import AllCountries from './AllCountries';
import './App.css';
import Header from './Header';

function App() {
  return (
    <div className="container-md">
      <Header />
      <AllCountries />
    </div>
  );
}

export default App;
